module.exports = __webpack_public_path__ + "static/media/partner3.6e5236eb.jpg";